import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setRatesMonitoring, setRatesVpsPaid } from '@/redux/rates/ratesSlice';

import ratesService from '@/services/ratesService';

const getRatesVpsPaid = () => async dispatch => {
  try {
    const response = await ratesService.getRatesVpsPaid();

    const {
      data: { data },
    } = response;
    const sortedRates = data.sort(
      (prev, next) => Number(prev.price) - Number(next.price),
    );

    dispatch(setRatesVpsPaid(sortedRates));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetRatesVpsPaid failure',
    );
  }
};

const getRatesMonitoring = () => async dispatch => {
  try {
    const response = await ratesService.getRatesMonitoring();

    const {
      data: { data },
    } = response;

    dispatch(setRatesMonitoring(data.sort((prev, next) => prev.id - next.id)));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetRatesMonitoring failure',
    );
  }
};

export default {
  getRatesVpsPaid,
  getRatesMonitoring,
};
